
const state =
[
  ["1","1","0","1","0","1","1","1","1","1"],
  ["0","L","E","M","O","0","1","0","0","1"],
  ["1","1","0","0","D","1","1","1","0","1"],
  ["1","0","1","0","I","0","1","0","1","1"],
  ["1","1","1","1","K","0","1","0","0","1"],
  ["1","0","1","0","R","0","1","0","0","1"],
  ["1","1","1","0","Y","S","S","E","T","0"],
  ["1","0","1","0","0","1","0","1","0","0"],
  ["1","1","1","1","1","1","1","1","1","1"]
];

export const frontPuzzle = { "pname": "FRONT", "state": state, "id": "srtd", "wordStarts": [], "arrows": [{ "x": 4, "y": 1, "direction": "d" }, { "x": 4, "y": 6, "direction": "r" }], "dashes": [], "viewSolution": true }
